// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ob-c";
export var backButton = "_ob-4";
export var backIcon = "_ob-5";
export var chevronShortcut = "_ob-6";
export var container = "_ob-1";
export var editor = "_ob-8";
export var editorWrapper = "_ob-7";
export var prefix = "_ob-2";
export var searchIcon = "_ob-3";
export var suffix = "_ob-9";
export var suffixContent = "_ob-a";
export var suffixText = "_ob-b";
export var wrapper = "_ob-0";